import PropTypes from 'prop-types';

import { ResidenceViewPropTypes, ResidenceViewDefaultProps } from '../../../Components/ResidenceView/ResidenceViewPropTypes';

export const FloorPlanPropTypes = {
  data: PropTypes.shape( {
    uuid: PropTypes.string,
    title: PropTypes.string,
    roomFees: PropTypes.arrayOf(
      PropTypes.shape( {
        label: PropTypes.string,
        data: PropTypes.string,
        note: PropTypes.string,
      } ),
    ),
    twoD: PropTypes.shape( {
      modal: PropTypes.string,
      oneThirdScreen: PropTypes.string,
    } ),
    threeD: PropTypes.shape( {
      modal: PropTypes.string,
      oneThirdScreen: PropTypes.string,
    } ),
    roomData: PropTypes.arrayOf(
      PropTypes.shape( {
        label: PropTypes.string,
      } ),
    ),
    view: ResidenceViewPropTypes.data,
    photoGalleryImages: PropTypes.arrayOf(
      PropTypes.shape( {
        id: PropTypes.string,
        // Supports both new API format (string) and legacy format (object)
        image: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.shape( {
            modal: PropTypes.string,
            fullScreen: PropTypes.string,
          } ),
        ]),
        caption: PropTypes.string,
      } ),
    ),
    threeSixties: PropTypes.arrayOf(
      PropTypes.shape( {
        id: PropTypes.string,
        image: PropTypes.string,
      } ),
    ),
    furnitureConfiguratorUrl: PropTypes.string,
    video: PropTypes.shape( {
      videoId: PropTypes.string,
      service: PropTypes.string,
    } ),
    finishCollection: PropTypes.shape( {
      id: PropTypes.string,
      title: PropTypes.string,
      options: PropTypes.arrayOf(
        PropTypes.shape( {
          title: PropTypes.string,
          fields: PropTypes.arrayOf(
            PropTypes.shape( {
              label: PropTypes.string,
              data: PropTypes.string,
            } ),
          ),
        } ),
      ),
    } ),
    downloadablePdf: PropTypes.string,
    floorPlanCategory: PropTypes.string,
    availableResidences: PropTypes.arrayOf(
      PropTypes.shape( {
        uuid: PropTypes.string,
        name: PropTypes.string,
        location: PropTypes.string,
        floor: PropTypes.string,
        svgId: PropTypes.string,
      } ),
    ),
  } ),
};

export const FloorPlanDefaultProps = {
  data: {
    uuid: null,
    title: '',
    roomFees: [],
    twoD: {},
    threeD: {},
    roomData: [],
    view: ResidenceViewDefaultProps.data,
    photoGalleryImages: [],
    threeSixties: [],
    furnitureConfiguratorUrl: '',
    video: {},
    finishCollection: {},
    downloadablePdf: '',
    floorPlanCategory: null,
    availableResidences: [],
  },
};
